<template>

  <div v-if="currentCompetition" class="edit-form">
    <h4>Stevne</h4>
    <form>
      <div class="form-group">
      <label for="title">Navn</label>
      <input type="text" class="form-control" id="title"
        v-model="currentCompetition.name"
      />
      </div>
      <div class="form-group">
      <label for="functions">Ønskede funksjoner:</label>
      <div>
        <input type="checkbox" id="liveres" name="function" value="liveres" 
        v-model="currentCompetition.functions">
        <label for="liveres">Frisys - Liveres</label>
      </div>
      <div>
        <input type="checkbox" id="opprop" name="function" value="opprop" 
        v-model="currentCompetition.functions">
        <label for="opprop">Frisys - Opprop</label>
      </div>
      </div>
      <div class="form-group">
      <label for="date_start">Dato start</label>
      <input type="text" class="form-control" id="date_start"
        v-model="currentCompetition.date_start"
      />
      </div>
      <div class="form-group">
      <label for="date_end">Dato slutt</label>
      <input type="text" class="form-control" id="date_end"
        v-model="currentCompetition.date_end"
      />
      </div>
      <div class="form-group">
      <label for="level">Nivå</label>
      <input type="text" class="form-control" id="level"
        v-model="currentCompetition.level"
      />
      </div>
      <div class="form-group">
      <label for="organizer">Arrangør</label>
      <input type="text" class="form-control" id="organizer"
        v-model="currentCompetition.organizer"
      />
      </div>
      <div class="form-group">
      <label for="external_webpage">Web (https:// +)</label>
      <input type="text" class="form-control" id="external_webpage"
        v-model="currentCompetition.external_webpage"
      />
      </div>
      <div class="form-group">
      <label for="venue_id">Stadion</label>
      <input type="text" class="form-control" id="venue_id"
        v-model="currentCompetition.venue_id"
      />
      </div>
      <div class="form-group">
      <label for="affiliation_field">Tilhørighet (Bør endres kun etter avtale med Andro)</label>
      <input type="text" class="form-control" id="affiliation_field"
        v-model="currentCompetition.affiliation.field"
      />
      <input type="text" class="form-control" id="affiliation_title"
        v-model="currentCompetition.affiliation.title"
      />
      </div>
      <div class="form-group" v-if="currentCompetition.functions.includes('liveres')">
      <label for="publishDate">Publiseringsdato</label>
      <input type="text" class="form-control" id="publishDate"
        v-model="currentCompetition.publishDate"
      />
      </div>
      <div class="form-group" v-if="currentCompetition.functions.includes('liveres')">
      <label for="hideMissingCallroomAfterFirstResult">Skjul manglende opprop etter første resultat</label>
      <input type="checkbox" id="hideMissingCallroomAfterFirstResult"
        v-model="currentCompetition.hideMissingCallroomAfterFirstResult"
      />
      </div>
      <div class="form-group" v-if="currentCompetition.functions.includes('opprop')">
      <label for="email_body">Epost hovedtekst</label>
      <textarea v-model="currentCompetition.email_body" cols="110" rows="10">
      </textarea>
      </div>

      <div class="form-group">
      <label><strong>Synlighet:</strong></label>
      {{ currentCompetition.hidden ? "Skjult" : "Synlig" }}
      </div>

      <div class="form-group">
      <label><strong>Aktiveringsstatus:</strong></label>
      {{ currentCompetition.adminApproved ? "Aktivert" : "Venter" }}
      </div>
    </form>

    <button class="badge badge-primary mr-2"
      v-if="currentCompetition.adminApproved && checkRole(['frisys_admin'])"
      @click="updatePublished(false)"
    >
      Fjern aktivering
    </button>
    <button v-else-if="checkRole(['frisys_admin'])" class="badge badge-primary mr-2"
      @click="updatePublished(true)"
    >
      Aktiver stevne
    </button>

    <!-- <button class="badge badge-danger mr-2"
      @click="deleteCompetition"
    >
      Slett stevne
    </button> -->

    <div v-if="isChanged" class="alert alert-success">
      <button type="submit" class="badge badge-success"
        @click="updateCompetition">
        Oppdater stevne
      </button><br />
      Ulagrede endringer... ({{ fieldsChanged.join(', ') }})
    </div>

    <p>{{ message }}</p>
  </div>

  <div v-else>
    <br />
    <p>Please click on a Competition...</p>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";

export default {
  name: "competition",
  data() {
    return {
      currentCompetition: null,
      initialCompetition: null,
      message: '',
      isChanged: false, // Add isChanged property
      fieldsChanged: []
    };
  },
  watch: {
    currentCompetition: {
      handler(newVal, oldVal) {
        console.log("currentCompetition changed", newVal, oldVal);
        if (newVal !== this.initialCompetition) {
          this.fieldsChanged = [];
          for (const key in newVal) {
            if (typeof newVal[key] === 'object' && newVal[key] !== null) {
              if (JSON.stringify(newVal[key]) !== JSON.stringify(this.initialCompetition[key])) {
              this.fieldsChanged.push(key);
              }
            } else {
              if (newVal[key] !== this.initialCompetition[key]) {
              this.fieldsChanged.push(key);
              }
            }
          }
          if (this.fieldsChanged.length > 0) {
            this.isChanged = true;
          } else {
            this.isChanged = false;
          }
          console.log("fieldsChanged", this.fieldsChanged);
        } else {
          this.isChanged = false;
          this.fieldsChanged = [];
        }
      },
      deep: true
    }
  },
  methods: {
    getCompetition(id) {
      CompetitionDataService.get(id)
        .then(response => {
          this.currentCompetition = response.data[0];
          this.initialCompetition = JSON.parse(JSON.stringify(this.currentCompetition));
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updatePublished(status) {
      // var data = {
      //   id: this.currentCompetition._id,
      //   title: this.currentCompetition.title,
      //   description: this.currentCompetition.description,
      //   published: status
      // };
      this.currentCompetition.adminApproved=status

      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          this.currentCompetition.adminApproved = status;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateCompetition() {
      if (!this.currentCompetition.external_webpage.startsWith("https://")) {
        console.log("Adding https:// to external_webpage");
        this.currentCompetition.external_webpage = "https://" + this.currentCompetition.external_webpage;
      }
      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          console.log(response.data);
          this.$store.dispatch('competition/updateActiveCompetitions');
          this.message = 'Stevnet ble lagret! (3 ...)';
          // Scroll to bottom of page
          this.$nextTick(() => {
            window.scrollTo(0, document.body.scrollHeight);
          });
          // Update countdown text every second
          let count = 3;
          const interval = setInterval(() => {
            count--;
            this.message = `Stevnet ble lagret! (${count} ...)`;
            if (count === 0) {
              clearInterval(interval);
              this.message = '';
              this.getCompetition(this.$route.params.competition_id);
            }
          }, 1000);
        })
        .catch(e => {
          console.log(e);
        });
    },

    deleteCompetition() {
      CompetitionDataService.delete(this.currentCompetition.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "competitions" });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    console.log("Competition - mounted")
    this.message = '';
    this.getCompetition(this.$route.params.competition_id);
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
